import React, { useState } from 'react';
import './LegalPages.css';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Use mailto link to send email
        const subject = encodeURIComponent(formData.subject || 'Contact from Website');
        const body = encodeURIComponent(
            `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
        );

        window.location.href = `mailto:exchange@tigermoml.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Contact Us</h1>

                <section>
                    <p>
                        Thank you for using our service! If you have any questions, suggestions, or feedback,
                        we'd love to hear from you. Please contact us through the following methods.
                    </p>
                </section>

                <section>
                    <h2>Contact Information</h2>
                    <div className="contact-info">
                        <div className="contact-item">
                            <span className="contact-icon">📧</span>
                            <div>
                                <h3>Email</h3>
                                <p>
                                    <a href="mailto:exchange@tigermoml.com">exchange@tigermoml.com</a>
                                </p>
                                <p className="note">We typically respond within 1-2 business days</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <h2>Send a Message</h2>
                    <p className="form-description">
                        Fill out the form below and we'll get back to you as soon as possible.
                    </p>

                    <form className="contact-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Name *</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="Enter your name"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="your@email.com"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="subject">Subject</label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                placeholder="Briefly describe your question or suggestion"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="message">Message *</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows="6"
                                placeholder="Please describe your question, suggestion, or feedback in detail"
                            ></textarea>
                        </div>

                        <button type="submit" className="submit-button">
                            Send Message
                        </button>

                        <p className="form-note">
                            * Required fields. Clicking send will open your default email client.
                        </p>
                    </form>
                </section>

                <section>
                    <h2>Frequently Asked Questions</h2>
                    <div className="faq">
                        <div className="faq-item">
                            <h3>Are my files safe?</h3>
                            <p>
                                Yes! All file processing is done locally in your browser,
                                we do not upload, store, or access any of your files.
                            </p>
                        </div>

                        <div className="faq-item">
                            <h3>Why are there ads?</h3>
                            <p>
                                We maintain the website's operating costs through displaying appropriate advertisements.
                                All core features are completely free with no restrictions.
                            </p>
                        </div>

                        <div className="faq-item">
                            <h3>Which browsers are supported?</h3>
                            <p>
                                We support the latest versions of all modern browsers, including Chrome, Firefox, Safari, and Edge.
                                For the best experience, please use the latest version of your browser.
                            </p>
                        </div>

                        <div className="faq-item">
                            <h3>How large can files be?</h3>
                            <p>
                                File size is mainly limited by your browser and device performance.
                                Generally, processing files of several tens of MB is no problem.
                                For particularly large files, processing time may be longer.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Contact;
